import script from "./HealthGoalCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./HealthGoalCard.vue?vue&type=script&lang=ts&setup=true"

import "./HealthGoalCard.vue?vue&type=style&index=0&id=0b51ce5d&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b51ce5d"]])

export default __exports__